import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import Benefit from 'models/ValueProposition/Benefit';
import { axiosBaseQuery } from 'services/api';

// Tags for cache invalidation
export const BENEFIT_TAG = 'Benefit';

export const benefitApi = createApi({
  reducerPath: 'benefitApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/',
  }),
  tagTypes: [BENEFIT_TAG],
  endpoints: builder => ({
    // Get list of benefits
    getBenefits: builder.query({
      query: ({ project, product, segment }) => ({
        url: `projects/${project}/products/${product}/segments/${segment}/benefits/`,
      }),
      transformResponse: data => List(data.map(benefit => new Benefit(benefit))),
      providesTags: [BENEFIT_TAG],
    }),
    // Fetch segment benefits
    fetchSegmentBenefits: builder.query({
      query: ({ projectId, productId, segmentIds = [] }) => ({
        url: `projects/${projectId}/products/${productId}/benefits/?segments=${segmentIds.join(',')}`,
      }),
      transformResponse: data => List(data.map(benefit => new Benefit(benefit))),
      providesTags: [BENEFIT_TAG],
    }),
    // Create benefit
    createBenefit: builder.mutation({
      query: ({ project, product, segment, ...data }) => ({
        url: `projects/${project}/products/${product}/segments/${segment}/benefits/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [BENEFIT_TAG],
    }),

    // Update benefit
    updateBenefit: builder.mutation({
      query: ({ project, product, segment, benefitId, ...data }) => ({
        url: `projects/${project}/products/${product}/segments/${segment}/benefits/${benefitId}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [BENEFIT_TAG],
    }),

    // Delete benefit
    deleteBenefit: builder.mutation({
      query: ({ project, product, segment, benefitId }) => ({
        url: `projects/${project}/products/${product}/segments/${segment}/benefits/${benefitId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [BENEFIT_TAG],
    }),
  }),
});

export const {
  useGetBenefitsQuery,
  useCreateBenefitMutation,
  useUpdateBenefitMutation,
  useDeleteBenefitMutation,
  useFetchSegmentBenefitsQuery,
} = benefitApi;
